<template>
    <div class="file">
        <span class="filename">{{ uploadedFileText }}</span>
        <div class="actions">
            <a class="edit" @click="$emit('edited-file')">{{ $t('Edit') }}</a>
            <a class="delete" @click="$emit('deleted-file')">{{ $t('Delete') }}</a>
        </div>
    </div>
</template>
<script>
import { i18n } from "./../../../../i18n";

export default {
    props: {
        text: {
            type: String,
            default: () => null
        },
    },
    computed: {
        uploadedFileText() {
            return this.text || this.t('Uploaded image')
        }
    },
    setup() {
        const {
            t
        } = i18n.global
        return {
            t
        }
    }
}
</script>